var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0.263674693%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B816",
    offset: "99.934016%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beispiel",
    transform: "translate(-841.000000, -196.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866,246 C879.807119,246 891,234.807119 891,221 C891,207.192881 879.807119,196 866,196 C852.192881,196 841,207.192881 841,221 C841,234.807119 852.192881,246 866,246 Z M871.302,229.266001 L871.302,232.230001 L855,232.230001 L855,229.266001 L871.302,229.266001 Z M877.230001,223.338 L877.230001,226.302 L855,226.302 L855,223.338 L877.230001,223.338 Z M871.302,215.928 L871.302,218.892 L855,218.892 L855,215.928 L871.302,215.928 Z M877.230001,210 L877.230001,212.964 L855,212.964 L855,210 L877.230001,210 Z",
    id: "Combined-Shape-Copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialText);
export default __webpack_public_path__ + "static/media/special_text.ff44be4e79fec03ffc70c3c9439dbc6e.svg";
export { ForwardRef as ReactComponent };